import { __GetContentTypeConfigNew } from "@/utils/getters/gettersV2";
import { extractAllBlocksFromTpl } from "@okf/ootils";
import { formatCamelCaseToSentenceCase } from "oolib";

export const getDerivedBlockTitle = ({ contentType, blockValuePath }) => {
  if (!contentType || !blockValuePath) return undefined;
  
  const tplTitle = __GetContentTypeConfigNew(contentType)?.general?.content?.title || contentType;
  const tplForBlocks = __GetContentTypeConfigNew(contentType);
  const blocks = tplForBlocks ? extractAllBlocksFromTpl({ tpl: tplForBlocks }) : [];
  const blockMeta = blocks.find(b => b.valuePath === blockValuePath);
  const labelFromMeta = blockMeta?.props?.label || blockMeta?.props?.shortLabel;
  const fieldLabel = labelFromMeta || formatCamelCaseToSentenceCase(blockValuePath?.replace("main.", "") || "");
  
  return `${tplTitle} - ${fieldLabel}`;
};

/**
 * Generate title for dimension-based widgets (BarChart, PieChart, HeatMapGrid)
 * @param {Object} dim1 - First dimension object with display or valuePath
 * @param {Object} dim2 - Second dimension object with display or valuePath
 * @returns {string|undefined} Generated title like "dim1 x dim2" or "dim1"
 */
export const getDerivedDimensionTitle = (dim1, dim2) => {
  const t1 = dim1?.display || dim1?.valuePath;
  const t2 = dim2?.display || dim2?.valuePath;
  if (t1 && t2) return `${t1} x ${t2}`;
  if (t1) return t1;
  return undefined;
};

/**
 * Generate title for time-series widgets (LineChart)
 * @param {Object} params
 * @param {Object} params.dateField - Date field object with display or valuePath
 * @param {Object} params.dimension - Dimension object for breakdown
 * @param {Object} params.interval - Interval object with value (hour, day, week, month, year)
 * @returns {string|null} Generated title like "Daily Date X Dimension"
 */
export const getDerivedTimeSeriesTitle = ({ dateField, dimension, interval }) => {
  if (!dateField) return null;
  
  const intervalDisplay = {
    'hour': 'Hourly',
    'day': 'Daily',
    'week': 'Weekly',
    'month': 'Monthly',
    'year': 'Yearly'
  }[interval?.value] || interval;

  const dateDisplay = dateField?.display || dateField?.valuePath || 'Date';
  
  if (!dimension) {
    return `${intervalDisplay} ${dateDisplay}`;
  }
  
  const dimensionDisplay = dimension?.display || dimension?.valuePath || 'Dimension';
  return `${dateDisplay} X ${dimensionDisplay}`;
};